import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ClassStudentsService {
  token = localStorage.getItem('token');

  constructor(private http: HttpClient) { }

  saveStudentsSelfcheckout(body) {
    return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/students/self-checkout`, body);
  }

  
  getSingleClass(classId) {
    return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/classes/${classId}`);
}
}
